<template>
  <a-card :bordered="false" class="m-b-20">
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
       <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        <a-week-picker v-else-if="search.search_date_type=='2'" @change="changeWeek" v-model:value="weekTime" :disabledDate="disabledDate" />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <SmallSquare class="m-b-10" content='总部仓库转化分析' />
    <div class="width90 info">
      <div style="background-color:rgb(129, 211, 248)" class="height-100 s_flex_bian_c p-l-30 p-r-80 s_over_h s_text_c">
          <div>
            <p>入库商品数量</p>
            <p>{{detail.warehouse_num || 0}}</p>
          </div>
          <div class="right triangle-down-1 s_cfff s_font_b "></div>
      </div>
      <div style="background-color:rgb(249, 199, 133)" class="height-100  s_flex_bian_c p-l-30 p-r-80 s_over_h s_text_c">
          <div class="s_flex_ali">
            <div class="m-r-20">
              <p>出库商品数量</p>
              <p>{{detail.out_warehouse_num || 0}}</p>
            </div>
            <div>
              <p>签收商品数量</p>
              <p>{{detail.sign_in_num || 0}}</p>
            </div>
          </div>
          <div class="right s_cfff triangle-down-2">
            出库商品
          </div>
      </div>
      <div style="background-color:rgb(244, 185, 192)" class="height-100 s_flex_bian_c p-l-30 p-r-80 s_over_h s_text_c">
          <div>
            <p>退货商品数量</p>
            <p>{{detail.refund_warehouse_num ||0}}</p>
          </div>
          <div class="right s_cfff s_font_b triangle-down-3">
            退货商品
          </div>
        </div>
        <div class="desc">
            <div>商品出库率{{(detail.out_warehousing_average) || 0}}</div>
            <div>商品退货率{{detail.refund_warehousing_average ||0}}</div>
        </div>
    </div>
  </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { generalWarehousingPosition } from "@/api/antiFleeing";
import { message } from "ant-design-vue";
export default {
  components: {},
  setup() {
    const momentTime = inject("momentTime");

    const search = ref({
      search_date_type: "1",
      start_time: "",
      end_time: "",
    });
    const state = reactive({
      detail:{},
      weekTime:"",
          disabledDate:function(current) {
        return current && current > momentTime().subtract(0, 'days').endOf('day')
      },
    });
   const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],

    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      changNav();
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          break;
     case "2":
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          break;
        case "4":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
      }
      console.log(
        dateTargets(search.value.search_time),
        search.value.search_time
      );
    };
    // 切换周
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };

    var $moment = inject("momentTime");
    const getLine = async () => {
      switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case "2":
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case "3":
          search.value.start_time = $moment(search.value.search_time)
            .startOf("month")
            .format("YYYY-MM-DD");
          search.value.end_time = $moment(search.value.search_time)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
      let result = await generalWarehousingPosition({
        ...search.value,
      })
        .then((res) => res.data)
        .catch((error) => error);
        state.detail=result.data
      return ;
    };
    // 线性图表
    const echartsLine = ref("");
    var pie;
    const changNav = async () => {
      var lines = await getLine();
    };
    onMounted(() => {
      handleChange("1");
      changNav(1);
    });

    return {
      ...toRefs(state),
      search,
      ...toRefs(dateTime),
      handleChange,
      changeWeek,
      changNav,
      onSearch,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;
  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.info{
    position: relative;
    &::before{
        content: '';
        position: absolute;
        border-bottom: 300px solid #fff;
        border-left: 150px solid transparent;
        width: 280px;
        right: 0;
    }
    .desc{
        position: absolute;
        z-index: 1;
        right: 0;
        border: 1px solid #000;
        height: 200px;
        top: 50%;
        width: 160px;
        right: 40px;
        transform: translateY(-50%);
        border-left: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        div{
            position: absolute;
            right: -20px;
            background-color: #fff;
            color: #000;
        }
        div:nth-child(1){
            top: 60px;
        }
        div:nth-child(2){
            top: 160px;
            &::before{
                content: '';
                height: 1px;
                width: 150px;
                background-color: #000;
                top: -40px;
                right: 20px;
                position: absolute;
            }
        }
    }
}
.triangle-down-1{
    width: 400px;
    height: 0;
   border-top: 200px solid rgb(27, 160, 251);
    border-left: 100px solid transparent;
    border-right: 100px solid transparent; 
    position: relative;
    z-index: 2;
    &::before{
        content: '入库商品';
        position: absolute;
        color: #fff;
        left: 50%;
        text-align: center;
        top: -100px;
        width: 70px;
        transform: translateX(-50%);
    }
}
.triangle-down-2{
    width: 300px;
    height: 0;
    border-top: 200px solid rgb(254, 168, 47);
    border-left: 100px solid transparent;
    border-right: 100px solid transparent; 
    z-index: 2;
    margin-right: 50px;
    position: relative;
    &::before{
        content: '出库商品';
        position: absolute;
        color: #fff;
        left: 50%;
        text-align: center;
        top: -100px;
        width: 70px;
        transform: translateX(-50%);
    }
}
.triangle-down-3{
    width: 200px;
    height: 0;
    border-top: 200px solid rgb(254, 91, 96);
    border-left: 100px solid transparent;
    border-right: 100px solid transparent; 
    margin-right: 100px;
    z-index: 2;
    position: relative;
    &::before{
        content: '退货商品';
        position: absolute;
        color: #fff;
        left: 50%;
        text-align: center;
        top: -100px;
        width: 70px;
        transform: translateX(-50%);
    }
}
</style>